import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'
import Divider from 'material-ui/Divider'

import SearchBox from 'billing/common/SearchBox'
import MaterialsList from './MaterialsList'
import BillingItemsList from './BillingItemsList'

import actionAddIcon from 'resources/actions_box_add_icon.png'

const Action = ({ display, onClick }) => {
  return (
    <div style={styles.action} onClick={onClick}>
      <img src={actionAddIcon} width={14} height={14} />
      <div style={{ marginLeft: 4 }}>{ display }</div>
    </div>
  )
}

Action.propTypes = {
  display: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

const BillingItemsDialogActions = ({ onNewItemClicked, onNewMaterialClicked }) => {
  return (
    <div style={styles.actions}>
      <Action display='New item' onClick={onNewItemClicked} />
      <Action display='New material' onClick={onNewMaterialClicked} />
    </div>
  )
}

BillingItemsDialogActions.propTypes = {
  onNewItemClicked: PropTypes.func.isRequired,
  onNewMaterialClicked: PropTypes.func.isRequired
}

export default class AddBillingItemDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    anchorElement: PropTypes.object,
    onBillItemSelected: PropTypes.func.isRequired,
    onMaterialSelected: PropTypes.func.isRequired,
    onCloseRequested: PropTypes.func.isRequired,
    onNewItemActionSelected: PropTypes.func.isRequired,
    onNewMaterialActionSelected: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      searchTerm: ''
    }
  }

  handleSearchBoxValueChanged = value => {
    this.setState({
      searchTerm: value
    })
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Popover
        open={this.props.open}
        anchorEl={this.props.anchorElement}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        style={{ borderRadius: 4 }}
        useLayerForClickAway={false} // Avoid flashy effect when rendering the popover.
        onRequestClose={this.props.onCloseRequested}>
        <SearchBox
          onValueChanged={this.handleSearchBoxValueChanged} />
        <BillingItemsList
          searchTerm={this.state.searchTerm}
          onItemSelected={this.props.onBillItemSelected} />
        <Divider />
        <MaterialsList
          searchTerm={this.state.searchTerm}
          onItemSelected={this.props.onMaterialSelected} />
        <Divider />
        <BillingItemsDialogActions
          onNewItemClicked={this.props.onNewItemActionSelected}
          onNewMaterialClicked={this.props.onNewMaterialActionSelected} />
      </Popover>
    )
  }

}

const styles = {
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  action: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    paddingTop: 8,
    paddingBottom: 8,
    color: '#4a4a4a',
    fontSize: 14
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/modules/items/AddBillingItemDialog.js